import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-token-library";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-utilities-library/styles";
import "../../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../../atomic/assets/image/background.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
const CreateGifElement = ({ image }) => {
  const container = document.createElement("div");
  const calculateHeight = () => {
    if (!image.naturalWidth || !image.naturalHeight) return;
    const aspectRatio = image.naturalHeight / image.naturalWidth;
    const containerWidth = container.offsetWidth;
    if (containerWidth > 0) {
      const calculatedHeight = Math.round(containerWidth * aspectRatio);
      container.style.height = `${calculatedHeight}px`;
    } else {
      container.style.width = `${image.naturalWidth}px`;
      setTimeout(() => {
        const containerWidth2 = container.offsetWidth;
        const calculatedHeight = Math.round(containerWidth2 * aspectRatio);
        container.style.height = `${calculatedHeight}px`;
      }, 100);
    }
  };
  const resizeObserver = new ResizeObserver(() => {
    container.style.width = `${image.naturalWidth}px`;
    setTimeout(() => {
      calculateHeight();
    }, 10);
  });
  if (image.complete && image.naturalWidth) {
    container.style.width = `${image.naturalWidth}px`;
    setTimeout(() => {
      calculateHeight();
    }, 10);
  } else {
    image.addEventListener("load", calculateHeight);
  }
  setTimeout(() => {
    resizeObserver.observe(container);
  }, 0);
  const imageElement = createImageBackground({
    element: image,
    isShowCaption: true,
    isScaled: false,
    isGifAllowed: true,
    imageLoading: "lazy",
    customStyles: {
      width: "auto",
      height: "100%",
      display: "block"
    }
  });
  const elementModel = new ElementBuilder(container).withClassName("media-gif").withChild(imageElement).withStyles({
    element: {
      maxHeight: "100%",
      maxWidth: "100%",
      position: "relative",
      display: "block",
      overflow: "hidden"
    }
  }).build();
  return {
    ...elementModel,
    destroy: () => {
      resizeObserver.disconnect();
      image.removeEventListener("load", calculateHeight);
    }
  };
};
const createCompositeMediaGif = CreateGifElement;
export {
  createCompositeMediaGif
};
//# sourceMappingURL=gif.js.map
